/*
 * Cart notification qty / remove controls.
 * Active on the el-cabron template only (loaded conditionally from
 * snippets/cart-notification.liquid).
 *
 * Wires the +/- quantity buttons, direct quantity input, and trash
 * button rendered by sections/cart-notification-product.liquid (also
 * gated to el-cabron) up to Shopify's /cart/change.js endpoint. After
 * each change, re-renders the three sections that the existing
 * cart-notification.js already manages, then closes the drawer if the
 * cart becomes empty.
 *
 * Decoupled from Ride's <cart-items> / <cart-drawer-items> custom
 * elements — those scope themselves to the cart page or full cart
 * drawer, neither of which is rendered here.
 */
(function () {
  const notification = document.querySelector('cart-notification');
  if (!notification) return;

  const SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  const DEBOUNCE_MS = 250;
  let inputDebounce;
  let pending = false;

  async function changeLine(line, quantity) {
    if (pending) return;
    pending = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) return;
      const data = await res.json();

      SECTIONS.forEach((id) => {
        const target = document.getElementById(id);
        if (!target || !data.sections || !data.sections[id]) return;
        const parsed = new DOMParser().parseFromString(data.sections[id], 'text/html');
        const sectionEl = parsed.querySelector('.shopify-section');
        target.innerHTML = sectionEl ? sectionEl.innerHTML : data.sections[id];
      });

      if (data.item_count === 0 && typeof notification.close === 'function') {
        notification.close();
      }
    } catch (err) {
      // Surface the failure to the console for debugging but don't break the page.
      // eslint-disable-next-line no-console
      console.error('cart-notification-controls: change failed', err);
    } finally {
      pending = false;
    }
  }

  notification.addEventListener('click', (event) => {
    const trash = event.target.closest('[data-cart-remove]');
    if (trash) {
      event.preventDefault();
      event.stopPropagation();
      const line = parseInt(trash.getAttribute('data-cart-remove'), 10);
      if (Number.isFinite(line)) changeLine(line, 0);
      return;
    }

    const qtyBtn = event.target.closest('[data-cart-qty-btn]');
    if (qtyBtn) {
      event.preventDefault();
      event.stopPropagation();
      const wrap = qtyBtn.closest('.quantity');
      const input = wrap && wrap.querySelector('input[data-cart-line]');
      if (!input) return;
      const line = parseInt(input.getAttribute('data-cart-line'), 10);
      const current = parseInt(input.value, 10) || 0;
      const next = Math.max(0, current + (qtyBtn.getAttribute('data-cart-qty-btn') === 'plus' ? 1 : -1));
      input.value = next;
      if (Number.isFinite(line)) changeLine(line, next);
    }
  });

  notification.addEventListener('change', (event) => {
    const input = event.target.closest('input[data-cart-line]');
    if (!input) return;
    clearTimeout(inputDebounce);
    inputDebounce = setTimeout(() => {
      const line = parseInt(input.getAttribute('data-cart-line'), 10);
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      if (Number.isFinite(line)) changeLine(line, qty);
    }, DEBOUNCE_MS);
  });
})();
